import script from "./AvailablePosition.vue?vue&type=script&setup=true&lang=js"
export * from "./AvailablePosition.vue?vue&type=script&setup=true&lang=js"

import "./AvailablePosition.vue?vue&type=style&index=0&id=2d394fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d394fc2"]])

export default __exports__